<template>
  <div class="container-fluid" id="fund-page">

    <div class="row">

      <div class="col-md-7 mx-auto">

        <h1 class="text-center mt-3">Total Value: {{ totalValueBGN }} BGN</h1>

        <div v-if="assets" class="mb-4 clearfix">
            <pie-chart :assets="assets"></pie-chart>
            <assets-table :coins="assets"></assets-table>
            <b-btn size="sm" class="float-left" variant="secondary" @click="onCopy(this)">copy table</b-btn>
            <span v-show="copyVisible" class="text-muted ml-2">copied!</span>
        </div>
        <div v-if="!assets && !loading" class="alert alert-danger text-center">No Chart Data</div>

        <h3 class="mt-5">Return on Investment (BGN)</h3>
        <totals-table v-if="stats" :data="stats"></totals-table>
        <div v-if="!stats && !loading" class="alert alert-danger text-center">No ROI Data</div>
      </div>

      <loading :loading="loading"></loading>

    </div>

  </div>
</template>


<script>
import AssetsTable from '../components/tables/AssetsTable'
import TotalsTable from '../components/tables/PortfolioTotalsTable'
import PieChart from '../components/charts/AssetsPieChart'

export default {
  components: {
    PieChart,
    AssetsTable,
    TotalsTable,
  },
  created() {
    this.loading = true
    this.$store.dispatch('loadTotalPortfolios')
      .finally(() => {
        this.loading = false
      })
  },
  data() {
    return {
      loading: false,
      copyVisible: false,
    }
  },
  methods: {
    onCopy() {
      let assettable = document.getElementById('assets_table_fund')
      let toformat = assettable.querySelectorAll('.formatnum')
      toformat.forEach(
        (element) => {
          element.setAttribute('style', 'mso-number-format: \'0\\.00000000\'')
        }
      )
      let el = document.createElement('textarea')
      document.body.appendChild(el)
      el.value = assettable.outerHTML.replace(new RegExp('&nbsp;', 'g'), '').replace(/,/g, '.')
      // el.setAttribute('readonly', '')
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      this.copyVisible = true
      setTimeout(() => { this.copyVisible = false }, 1000)
    },
  },
  computed: {
    stats() {
      return this.$store.getters.getTPStats
    },
    assets() {
      return this.$store.getters.getTPAssets
    },
    totalValueBGN() {
      return this.stats ? this.stats.totalValueBGN : 0
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/-service-app/pages/FundPage.vue